import { z } from 'zod';
// ─── KB source manifest (KB-MCP tool output) ────────────
export const ECHO_SOURCE_MANIFEST_PREFIX = '<!--ECHO-SOURCES ';
export const ECHO_SOURCE_MANIFEST_SUFFIX = '-->';
export const EchoKbSourceItemSchema = z.object({
    ordinal: z.number().int().positive(),
    documentId: z.string().uuid(),
    filename: z.string(),
    headingPath: z.string().nullable(),
});
export const EchoKbSourceManifestSchema = z.object({
    version: z.literal(1),
    kbName: z.string(),
    items: z.array(EchoKbSourceItemSchema),
});
//# sourceMappingURL=kb-source.js.map